export function parseCoordinateNumber(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed || /[eE]/.test(trimmed)) return null;
    if (!/^-?\d+(\.\d+)?$/.test(trimmed)) return null;
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function normalizeCoordinatePair(location) {
  if (!location || location.available === false) {
    return { markerAvailable: false, latitude: null, longitude: null };
  }
  const latitude = parseCoordinateNumber(location.latitude);
  const longitude = parseCoordinateNumber(location.longitude);
  if (latitude == null || longitude == null) {
    return { markerAvailable: false, latitude: null, longitude: null };
  }
  if (latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180) {
    return { markerAvailable: false, latitude: null, longitude: null };
  }
  return { markerAvailable: true, latitude, longitude };
}
